import { render, staticRenderFns } from "./ListScrollbar.vue?vue&type=template&id=39d0e285&scoped=true&"
import script from "./ListScrollbar.vue?vue&type=script&lang=js&"
export * from "./ListScrollbar.vue?vue&type=script&lang=js&"
import style0 from "./ListScrollbar.vue?vue&type=style&index=0&id=39d0e285&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d0e285",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VScrollYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VIcon,VScrollYTransition})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
